import { atom, useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

const onboardingGuideTargetAtom = atom<HTMLDivElement | null>(null);

/** Width (px) of the onboarding guide dock; kept in sync with the portalled guide. */
export const ONBOARDING_GUIDE_WIDTH = 242;

export function useOnboardingGuideRoot() {
  return useAtomValue(onboardingGuideTargetAtom);
}

export function OnboardingGuideRoot({
  className,
}: {
  readonly className?: string;
}) {
  const setTarget = useSetAtom(onboardingGuideTargetAtom);
  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      setTarget(node);
    },
    [setTarget]
  );
  return <div ref={ref} className={className} />;
}
